import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Badge } from "@faire/web--source/slate/Badge";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";
import { CollapsibleContainer } from "./CollapsibleContainer";
export var ProductAttributeTagsMobile = function(param) {
    var productAttributeTags = param.productAttributeTags;
    var attributeTags = productAttributeTags.map(function(attribute) {
        return attribute.display_name ? /*#__PURE__*/ _jsx(AttributeTag, {
            content: attribute.display_name,
            backgroundColor: Core.surface.subdued
        }, attribute.display_name) : null;
    });
    return /*#__PURE__*/ _jsx(AttributeRowWrapperMobile, {
        children: attributeTags
    });
};
export var ProductAttributeTagsTabletAndAbove = function(param) {
    var productAttributeTags = param.productAttributeTags;
    var attributeTags = productAttributeTags.map(function(attribute) {
        return attribute.display_name ? /*#__PURE__*/ _jsx(AttributeTag, {
            content: attribute.display_name,
            backgroundColor: Core.surface.subdued
        }, attribute.display_name) : null;
    });
    return /*#__PURE__*/ _jsx(AttributeTagPillsContainer, {
        children: /*#__PURE__*/ _jsx(CollapsibleContainer, {
            thresholdHeight: ATTRIBUTE_TAG_HEIGHT * 2,
            children: /*#__PURE__*/ _jsx(AttributeRowWrapper, {
                children: attributeTags
            })
        })
    });
};
// eslint-disable-next-line @faire/prefer-slate-attrs -- false alarm
var AttributeRowWrapperMobile = styled(Row).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-1f82b784-0"
})([
    "white-space:nowrap;padding-top:",
    ";overflow-y:auto;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
], getSpacing("3x"));
// eslint-disable-next-line @faire/prefer-slate-attrs
var AttributeRowWrapper = styled(Row).withConfig({
    componentId: "sc-1f82b784-1"
})([
    "flex-wrap:wrap;gap:",
    ";"
], getSpacing("1x", "1x"));
var AttributeTagPillsContainer = styled(Row).withConfig({
    componentId: "sc-1f82b784-2"
})([
    "padding-top:",
    ";"
], getSpacing("3x"));
// This constant is used to calculate the threshold height to collapse tag pills
// If you are changing the size of the tag pill, please update this
var ATTRIBUTE_TAG_HEIGHT = 28;
var AttributeTag = styled(Badge).withConfig({
    componentId: "sc-1f82b784-3"
})([
    "padding:4px 12px;min-width:auto;"
]);
